export const environment = {
    url: "https://api-o2opartners.policystreet.app/api",
};
